<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="true && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>

            <div
              v-if="viewType === 'deviceList' || viewType === 'trayList'"
              class="list"
            >
              <DeviceList
                v-if="viewType === 'deviceList'"
                :company="company"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :selectEvent="selectEvent"
                @deviceDetail="deviceDetail"
                @deviceCreate="deviceCreate"
              ></DeviceList>
              <TrayList
                v-else-if="viewType === 'trayList'"
                :device="device"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :selectEvent="selectEvent"
                @trayDetail="trayDetail"
                @trayCreate="trayCreate"
              ></TrayList>
            </div>
            <div
              v-else-if="viewType === 'deviceDetail' || viewType === 'trayDetail'"
              class="detail"
            >
              <DeviceDetail
                v-if="viewType === 'deviceDetail'"
                :device="device"
                @trayList="selectNode"
                @refreshList="selectNode"
              ></DeviceDetail>
              <TrayDetail
                v-else-if="viewType === 'trayDetail'"
                :tray="tray"
                @refreshList="selectNode"
              ></TrayDetail>
            </div>
            <div
              v-else-if="viewType === 'deviceCreate' || viewType === 'trayCreate'"
              class="create"
            >
              <DeviceCreate
                v-if="viewType === 'deviceCreate'"
                :company="company"
                @refreshList="selectNode"
              ></DeviceCreate>
              <TrayCreate
                v-else-if="viewType === 'trayCreate'"
                :device="device"
                @refreshList="selectNode"
              ></TrayCreate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import DeviceList from '@/components/device/DeviceList';
import DeviceDetail from '@/components/device/DeviceDetail';
import DeviceCreate from '@/components/device/DeviceCreate';
import TrayList from '@/components/tray/TrayList';
import TrayDetail from '@/components/tray/TrayDetail';
import TrayCreate from '@/components/tray/TrayCreate';
import TreeView from '@/components/include/TreeView';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    DeviceList,
    DeviceDetail,
    DeviceCreate,
    TrayList,
    TrayDetail,
    TrayCreate,
    TreeView,
  },
  data: () => ({
    menu: null,
    treeType: 'device',
    treeScope: 'biz',
    viewType: 'deviceList',
    company: null,
    device: null,
    tray: null,
    selectEvent: 0,
    refreshEvent: 0,
    searchCondition: null,
    startTime: '',
    endTime: '',
    menuInfo: {
      mainTitle: 'Device',
      mainName: '재고 관리',
      subTitle: 'Device',
      subName: 'AI 냉장고 관리',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type, isTreeRefresh) {
      if (type === 'all') {
        this.company = null;
        this.device = null;
        this.tray = null;
        this.menuInfo.company = null;
        this.menuInfo.device = null;
        this.menuInfo.tray = null;
      } else if (type === 'company') {
        this.company = object;
        this.device = null;
        this.tray = null;
        this.menuInfo.company = object;
        this.menuInfo.device = null;
        this.menuInfo.tray = null;
        this.viewType = 'deviceList';
        this.selectEvent ^= 1;
      } else if (type === 'device') {
        this.company = null;
        this.device = object;
        this.tray = null;
        this.menuInfo.company = null;
        this.menuInfo.device = object;
        this.menuInfo.tray = null;
        this.viewType = 'trayList';
        this.selectEvent ^= 1;
      }

      if (isTreeRefresh) {
        this.refreshEvent ^= 1;
      }
    },
    deviceDetail(device) {
      this.company = null;
      this.device = device;
      this.tray = null;
      this.menuInfo.company = null;
      this.menuInfo.device = device;
      this.menuInfo.tray = null;
      this.viewType = 'deviceDetail';
      this.selectEvent ^= 1;
    },
    trayDetail(tray) {
      this.company = null;
      this.device = null;
      this.tray = tray;
      this.menuInfo.company = null;
      this.menuInfo.device = null;
      this.menuInfo.tray = tray;
      this.viewType = 'trayDetail';
      this.selectEvent ^= 1;
    },
    deviceCreate(company) {
      this.company = company;
      this.device = null;
      this.tray = null;
      this.menuInfo.company = company;
      this.menuInfo.device = null;
      this.menuInfo.tray = null;
      this.viewType = 'deviceCreate';
    },
    trayCreate(device) {
      this.company = null;
      this.device = device;
      this.tray = null;
      this.menuInfo.company = null;
      this.menuInfo.device = device;
      this.menuInfo.tray = null;
      this.viewType = 'trayCreate';
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/Device.vue